<template>
  <div class="timeChatBox">
    <!--    时间-->
    <div class="action">{{ time }}</div>
  </div>
</template>

<script>
export default {
  name: "timeChat",
  props:{
    time:{type: String, required:true}
  }
}
</script>

<style scoped>
.timeChatBox{
  position: relative;
  margin: auto;
  margin-top: 40px;
  width: 100%;
  font-size: 35px;
  line-height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  /*background-color: #005aff;*/
}
.action{
  color: #b2b2b2;
  /*margin-right: 4px;*/
}
</style>